// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InterestsForm_wrapper__0OEni","items-wrapper":"InterestsForm_items-wrapper__kHjh0"};